module.exports = __webpack_public_path__ + "img/ice-cream-emoji.ca15dc7c.png";